<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.11328 4.95996L7.99994 8.36662L13.8466 4.97994" stroke="url(#paint0_linear_7904_11464)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 14.4065V8.35986" stroke="url(#paint1_linear_7904_11464)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6.6204 1.6535L3.0604 3.63352C2.25374 4.08018 1.59375 5.20017 1.59375 6.12017V9.88685C1.59375 10.8069 2.25374 11.9268 3.0604 12.3735L6.6204 14.3535C7.3804 14.7735 8.62706 14.7735 9.38706 14.3535L12.9471 12.3735C13.7537 11.9268 14.4137 10.8069 14.4137 9.88685V6.12017C14.4137 5.20017 13.7537 4.08018 12.9471 3.63352L9.38706 1.6535C8.6204 1.22683 7.3804 1.22683 6.6204 1.6535Z" stroke="url(#paint2_linear_7904_11464)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M11.3335 8.82674V6.38676L5.00684 2.7334" stroke="url(#paint3_linear_7904_11464)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <defs>
      <linearGradient id="paint0_linear_7904_11464" x1="0.245694" y1="2.09742" x2="14.6216" y2="11.0668" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint1_linear_7904_11464" x1="7.84083" y1="3.27898" x2="9.54147" y2="3.32993" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint2_linear_7904_11464" x1="-0.446802" y1="-9.87163" x2="20.7326" y2="-6.18318" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
      <linearGradient id="paint3_linear_7904_11464" x1="3.99982" y1="-2.3867" x2="14.4009" y2="-0.430408" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FECBD4" />
        <stop offset="0.345047" stop-color="#EB008B" stop-opacity="0.8" />
        <stop offset="0.857321" stop-color="#AA0085" stop-opacity="0.85" />
        <stop offset="1" stop-color="#8A008A" />
      </linearGradient>
    </defs>
  </svg>
</template>
